module.exports = __webpack_public_path__ + "assets/img/jody-signin.408da608.png";